'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../node_modules/@radix-ui/react-popover/dist/index.cjs');
var React = require('react');
var useControlledState = require('../../../utils/hooks/useControlledState.cjs');
var Content_web = require('./Content/Content.web.cjs');
var Trigger_web = require('./Trigger/Trigger.web.cjs');

/**
 * A popover component for displaying content an absolutely positioned container
 *
 * {@link https://aviary.fullscript.io/latest/components/popover/web-CwmN8Qt3 | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Popover/Popover.web.tsx | View in GitLab}
 *
 * @scope Web
 */ const Popover = ({ isOpen, triggerCallback, openAction, children })=>{
    const [isPopoverOpen, setIsPopoverOpen] = useControlledState.useControlledState(!!isOpen, {
        value: isOpen ?? false,
        setValue: triggerCallback
    });
    const servicesRef = React.useRef(null);
    const handleOnClick = ()=>{
        if (openAction === "click") {
            if (triggerCallback) triggerCallback(true);
            setIsPopoverOpen(!isPopoverOpen);
        }
    };
    if (isOpen !== null) {
        return /*#__PURE__*/ jsxRuntime.jsx("div", {
            ref: servicesRef,
            onClick: handleOnClick,
            children: /*#__PURE__*/ jsxRuntime.jsx(index.Root, {
                open: isOpen,
                children: children
            })
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsx(index.Root, {
        children: children
    });
};
Popover.Trigger = Trigger_web.Trigger;
Popover.Content = Content_web.Content;

exports.Popover = Popover;
//# sourceMappingURL=Popover.web.cjs.map
